import { Box, Button, FormControl, MenuItem, Select, Typography } from '@mui/material';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import { DrawerHeaderWithLeftIcon } from '../../../../../components/Drawer/DrawerHeader';
import { useState } from 'react';
import { handleErrors } from '../../../../../utils/common';
import { BATCHES_TEST_IDS } from '../../../consts/testIds';

interface AsistenciaDrawerProps {
    handleCloseDrawer: () => void;
    selectedEmployees?: any[];
    handleMarkAsistencia?: (attendanceStatus: string) => Promise<boolean>;
    isLoading?: boolean;
}

const AsistenciaDrawer = ({
    handleCloseDrawer,
    selectedEmployees = [],
    handleMarkAsistencia,
    isLoading = false
}: AsistenciaDrawerProps) => {
    const [attendanceStatus, setAttendanceStatus] = useState('presente');
    const selectedCount = selectedEmployees.length;

    const handleSaveAttendance = async () => {
        try {
            if (handleMarkAsistencia) {
                const success = await handleMarkAsistencia(attendanceStatus);
                if (success) {
                    handleCloseDrawer();
                }
            }
        } catch (error) {
            handleErrors(error);
        }
    };

    return (
        <Box display="flex" flexDirection="column" height="100%" bgcolor="#F8FAFC">
            <Box px={2} pt={1} pb={0.5} bgcolor="#FFFFFF" borderBottom="1px solid #E2E8F0">
                <DrawerHeaderWithLeftIcon
                    onIconClick={handleCloseDrawer}
                    text={selectedCount > 1 ? 'Marcar Asistencia Masiva' : 'Marcar Asistencia'}
                    LeftIcon={<PersonAddAltOutlinedIcon sx={{ color: '#16A34A' }} />}
                />
            </Box>

            <Box flex={1} overflow="auto" px={3} py={3}>
                <Typography fontSize="0.9rem" color="#475569" fontWeight={500} mb={3}>
                    Registrando asistencia para{' '}
                    <Box component="span" fontWeight={700} color="#0F172A">
                        {selectedCount}
                    </Box>{' '}
                    empleados.
                </Typography>

                <Box>
                    <Typography
                        fontSize="0.72rem"
                        fontWeight={700}
                        color="#64748B"
                        textTransform="uppercase"
                        letterSpacing={0.6}
                        mb={1}
                        ml={0.5}
                    >
                        Estado de Asistencia
                    </Typography>
                    <FormControl fullWidth size="small">
                        <Select
                            value={attendanceStatus}
                            onChange={(event) => setAttendanceStatus(event.target.value)}
                            inputProps={{ 'data-testid': BATCHES_TEST_IDS.drawers.asistencia.attendanceStatus }}
                            sx={{
                                bgcolor: '#FFFFFF',
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#D1D5DB'
                                }
                            }}
                        >
                            <MenuItem value="presente">Presente</MenuItem>
                            <MenuItem value="ausente">Ausente</MenuItem>
                            <MenuItem value="baja">Baja (No corresponde)</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
            </Box>

            <Box px={2} py={2} bgcolor="#FFFFFF" borderTop="1px solid #E2E8F0">
                <Box display="flex" justifyContent="flex-end" gap={1.5}>
                    <Button
                        variant="text"
                        onClick={handleCloseDrawer}
                        data-testid={BATCHES_TEST_IDS.drawers.asistencia.cancelButton}
                        sx={{
                            color: '#475569',
                            textTransform: 'none',
                            fontWeight: 500
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSaveAttendance}
                        disabled={isLoading}
                        data-testid={BATCHES_TEST_IDS.drawers.asistencia.confirmButton}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                            boxShadow: '0 1px 2px rgba(37, 99, 235, 0.2)'
                        }}
                    >
                        {isLoading ? 'Guardando...' : 'Confirmar'}
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export { AsistenciaDrawer };
